const PREV_KEYS = new Set(['ArrowUp', 'ArrowLeft']);
const NEXT_KEYS = new Set(['ArrowDown', 'ArrowRight']);

export function isChoiceNavigationKey(key: string) {
  return PREV_KEYS.has(key) || NEXT_KEYS.has(key);
}

export function getNextFocusableIndex(
  current: number,
  key: string,
  total: number,
  isFocusable: (index: number) => boolean,
): number | null {
  if (total === 0 || !isChoiceNavigationKey(key)) return null;

  const direction = NEXT_KEYS.has(key) ? 1 : -1;
  let next = current;

  for (let i = 0; i < total; i++) {
    next = (next + direction + total) % total;
    if (isFocusable(next)) return next;
    if (next === current) break;
  }

  return null;
}

export function findFirstFocusableIndex(
  total: number,
  isFocusable: (index: number) => boolean,
): number {
  for (let i = 0; i < total; i++) {
    if (isFocusable(i)) return i;
  }
  return 0;
}
